import React from "react";
import History from "Pages/Transactio-History";


const Hisotrytheme = () => {
  return (
    <React.Fragment>
        <History/>
    </React.Fragment>
  );
};

export default Hisotrytheme;
